import { DayOfWeek } from 'core/day-of-week';
import { Hours, Minutes, WorkingDaysConfiguration } from './types';

export const DefaultWorkingDayConfig: WorkingDaysConfiguration = {
  [DayOfWeek.Monday]: true,
  [DayOfWeek.Tuesday]: true,
  [DayOfWeek.Wednesday]: true,
  [DayOfWeek.Thursday]: true,
  [DayOfWeek.Friday]: true,
  [DayOfWeek.Saturday]: false,
  [DayOfWeek.Sunday]: false,
};

export const getCapacityInMinutesForADay = (
  capacityInHoursForWeek: Hours,
  workingDays: WorkingDaysConfiguration = DefaultWorkingDayConfig,
): Minutes => {
  const numberOfWorkingDays = Object.values(workingDays).filter(
    (x) => x,
  ).length;
  const capacityInMinutes = capacityInHoursForWeek * 60;

  return Math.floor(capacityInMinutes / numberOfWorkingDays);
};

export const getCapacityInHoursForADay = (
  capacityInHoursForWeek: Hours,
  workingDays: WorkingDaysConfiguration = DefaultWorkingDayConfig,
): Hours => {
  const numberOfWorkingDays = Object.values(workingDays).filter(
    (x) => x,
  ).length;

  return Math.floor(capacityInHoursForWeek / numberOfWorkingDays);
};
